import { useStopWatchCountDown } from "global-components-library";

import { useEffect, useState } from "react";


const StopWatch = ({ onChange, hours, minutes, secondsInitial,isAscending }) => {
  let { start, stop, fullFormat, seconds } = useStopWatchCountDown(hours, minutes, secondsInitial,1000,isAscending);
  const [complete, setComplete] = useState("00:00:00");

  useEffect(() => {
    start();
    return () => {
      stop();
    }
  }, []);

  useEffect(() => {
    let result = fullFormat();
    onChange(result);
    setComplete(result);
  }, [seconds]);

  return complete;
};


export default StopWatch;



// WEBPACK FOOTER //
// ./src/components/Header/StopWatch/StopWatch.jsx